export interface BookingCancellationResponse {
  bookingReference: string;
  refundSuccessful: boolean;
  refunded: {
    amount: number;
    currency: string;
  };
  errorCode: string;
}
